import {BaseNomenclatorModel} from './base.model';

export class ProductCategoryModel extends BaseNomenclatorModel{
    uid: string;
    name: string;
}

